import { MediaTypes } from '@setplex/tria-api'
import { type IContinueWatchingCardFormat } from '~/entities/continue-watching'

type isContinueWatchingVodAndLockedArgs = Pick<
  IContinueWatchingCardFormat,
  'contentType' | 'locked'
>

export const isContinueWatchingVodAndLocked = ({
  locked,
  contentType,
}: isContinueWatchingVodAndLockedArgs) =>
  contentType === MediaTypes.VOD && Boolean(locked)
